export default "__VITE_ASSET__C87Kxdi6__"